import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import classes from './ClaimRouletteAnimation.module.scss';
import { ClaimRouletteRiveAnimation } from './ClaimRouletteRiveAnimation/ClaimRouletteRiveAnimation';

function ClaimRouletteAnimationComponent() {
  const { rouletteStore } = useStores();
  const { claimRouletteAnimationState } = rouletteStore;

  if (!claimRouletteAnimationState.enable) {
    return null;
  }

  const animationKey = `${claimRouletteAnimationState.coinType}-${claimRouletteAnimationState.rouletteAmount}`;

  return (
    <div className={classes.claimRouletteAnimation}>
      <ClaimRouletteRiveAnimation
        key={animationKey}
        amount={claimRouletteAnimationState.rouletteAmount}
        input={claimRouletteAnimationState.coinType === 'SC' ? 'green' : 'yellow'}
        onAnimationEnd={() => {
          claimRouletteAnimationState.onAnimationEnd?.();
        }}
      />
    </div>
  );
}

export const ClaimRouletteAnimation = observer(ClaimRouletteAnimationComponent);
